module.exports = __webpack_public_path__ + "static/img/Ring-of-day-blue.b62c17d9.svg";